import { useValuationsStore } from '../../store/valuationsStore';
import { Badge } from '../Badge';

const AssetBadges = () => {
  const selectedAsset = useValuationsStore.use.selectedAssetDetails();
  const disabled = selectedAsset === null;

  if (!selectedAsset?.mAndAOpportunity) {
    return null;
  }

  return (
    <Badge variant='ma' disabled={disabled} data-id='asset-details-ma-badge'>
      M&A OPPORTUNITY
    </Badge>
  );
};

export { AssetBadges };
